<template>
  <div class="modal-content">
    <div class="modal-body">
      <tag-details :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :component="component" v-on:close="hideModal" v-on:save="save" />
    </div>
  </div>
</template>

<script>

import TagDetails from '~/components/TagDetails'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'component'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (tag) {
      this.$emit('save', tag)
    }
  },
  components: {
    TagDetails
  }
}

</script>